import { render, staticRenderFns } from "./LImageViewDialog.vue?vue&type=template&id=8b557188&scoped=true"
import script from "./LImageViewDialog.vue?vue&type=script&lang=js"
export * from "./LImageViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b557188",
  null
  
)

export default component.exports